import type { VueI18n } from 'vue-i18n';
import type { Ref } from 'vue';

export const I18nService = Symbol.for('I18nService');

export interface I18nService {
    locale: Ref<VueI18n['locale']>;
    t: VueI18n['t'];
    te: VueI18n['te'];
}
